import React from 'react'

import '../styles/info.css'

const Info = () => (
  <div className='info'>
    <h1 className='title'>
      Jonathan Petit
    </h1>
		<p className='study'>
      2nd master software engineer, ECAM brussels.
		</p>  
  </div>
)

export default Info